import React, { Fragment, useState } from 'react'
import Component from 'components/component'
import { DI } from 'modules'

import HeaderClear from './header-clear'
import HeaderMain from './header-main'
import SignIn from './sign-in'
import SignUp from './sign-up'
import { IS_LANDING } from '../../config'

export function Header(props) {
  const { common, actions } = props

  const [floatFixed, setFloatFixed] = useState(false)

  const onChangeFloatFixed = newFloatFixed => {
    if (floatFixed !== newFloatFixed) {
      setFloatFixed(newFloatFixed)
    }
  }

  const toggleSignInModal = ev => {
    ev && ev.preventDefault()
    if (common.signInModal.isOpen) {
      actions.common.closeSignInModal()
    } else {
      actions.common.openSignInModal()
    }
  }

  const toggleSignUpModal = ev => {
    ev && ev.preventDefault()
    if (common.signUpModal) {
      actions.common.closeSignUpModal()
    } else {
      actions.common.openSignUpModal()
    }
  }

  const floatClassList = Component.classList(
    'float-header',
    floatFixed && '_fixed',
    common.landingPage && 'float-header--landing j-float-header'
  )

  if (common.clearPage) {
    return (
      <>
        <HeaderClear />
        {common.signInModal.isOpen && <SignIn onClose={toggleSignInModal} />}
      </>
    )
  }
  return (
    <Fragment>
      <header className={floatClassList}>
        <HeaderMain openSignInModal={toggleSignInModal} />
      </header>
      <header
        className={Component.classList(
          'header',
          common.landingPage && 'header--landing'
        )}
      >
        <HeaderMain
          onChangeFixed={onChangeFloatFixed}
          openSignInModal={toggleSignInModal}
          openSignUpModal={toggleSignUpModal}
        />
      </header>
      {common.signInModal.isOpen && <SignIn onClose={toggleSignInModal} />}
      {common.signUpModal && IS_LANDING && (
        <SignUp
          onClose={toggleSignUpModal}
          openSignInModal={toggleSignInModal}
        />
      )}
    </Fragment>
  )
}

export default DI()(Header)
